import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";

import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/Login";
import CreateAccount from "./pages/CreateAccount";
import ForgetPassword from "./pages/ForgetPassword";
import Enrollee from "./pages/Enrollee";
import Dashboard from "./pages/Dashboard";
import Notifications from "./pages/Notifications";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HelpAndSupport from "./pages/HelpAndSupport";
import UserProfile from "./pages/UserProfile";
import ProtectedRoute from "./ProtectedRoute";
import VerifyOtp from "./pages/VerifyOtp";
import ResetPassword from "./pages/ResetPassword";
import TermsAndConditions from "./pages/TermsAndConditions";
import EnrolleDetails from "./pages/EnrolleDetails";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route exact path="/login" element={<Login />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/verify-otp/:email" element={<VerifyOtp />} />
          <Route path="/reset-password/:email/:otp" element={<ResetPassword />} />
          <Route path="/privacy-and-security" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/:id" element={<EnrolleDetails />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/add-enrollee" element={<Enrollee />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/help-and-support" element={<HelpAndSupport />} />
            <Route path="/user-profile" element={<UserProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        transition={Slide}
        closeOnClick={true}
      />
    </Provider>
  );
}

export default App;
